module.exports = __webpack_public_path__ + "static/img/lap01.e0a8f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/lap01.png
// module id = sQIK
// module chunks = 11